<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'MGC',
			author: 'MGC',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
};
</script>

<template>
	<div class="row justify-content-sm-center">
		<div class="col-4 text-center my-2 font-general-regular text-lg text-ternary-dark dark:text-ternary-light">
			<p
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500">
				&copy; {{ copyrightDate }}. {{ projectName }}
				<img v-if="theme === 'light'" src="@/assets/images/mgc_logo.png" class="footer-logo" alt="Dark Logo"
					width="100" />
				<img v-else src="@/assets/images/mgc_logo_white.png" class="footer-logo" alt="Light Logo" width="100" />
			</p>
		</div>
	</div>
</template>

<style scoped>
.footer-logo {
	display: inline;
}
</style>
